import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {setApplicationDetails, setGeneralDetails, setLoginDetails} from "../../actions/actions";
import Loader from "../common/loader/loader";
import StateData from "../../resources/state_and_lga.json";
import stateData from "../../resources/state_and_lga.json";
import {formatDate} from "../../resources/constants";
import Header from "../common/header/header";
import Sidebar from "../common/sidebar/sidebar";
function PersonalInfo(props) {
    const navigate = useNavigate();
    const userId = props.applicationLogin.EntryID;
    const [isFormLoading, setisFormLoading] = useState('off')
    const [activeLink, setActiveLink] = useState(false);
    const [userData] = useState(props.applicationLogin);
    const [applicantData, setApplicationData] = useState({
        EntryID: "",
        FirstName: "",
        MiddleName: "",
        Surname: "",
        PhoneNumber: "",
        EmailAddress: "",
        DateOfBirth: "",
        Gender: "",
        Nationality: "",
        StateOfOrigin: "",
        Occupation: "",
        Religion: "",
        Address: "",
    });

    // const [lgaList, setLGAList] = useState(
    //     StateData.filter(
    //         (state) => state.state === props.applicationLogin.StateOfOrigin
    //     )[0].lgas
    // );

    const [lgaList, setLGAList] = useState(() => {
        const selectedState = StateData.find(
            (state) => state.state === props.applicationLogin.StateOfOrigin
        );
        return selectedState ? selectedState.lgas : [];
    });


    const [shouldSave, setShouldSave] = useState(false);

    useEffect(() => {
        async function getUserData() {
            axios
                .get(`${serverLink}application/user/${userId}`)
                .then((response) => {
                    if (response.data.message === 'success'){
                        const res = response.data.data[0];
                        setApplicationData({
                            ...res,
                            DateOfBirth: formatDate(res.DateOfBirth), // res.DateOfBirth.split("T")[0],
                        });
                    }
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        }
        getUserData();
    }, []);

    const handleChange = (e) => {
        const value = e.target.value;
        const id = e.target.id;

        setShouldSave(true);

        if (id === "StateOfOrigin") {
            if (value !== "") {
                setLGAList(StateData.filter((state) => state.state === value)[0].lgas);
            } else {
                setLGAList([]);
            }
        }
        setApplicationData({ ...applicantData, [e.target.id]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        for (let item in applicantData) {
            if (
                applicantData.hasOwnProperty(item) &&
                item !== "Occupation" &&
                item !== "MiddleName"
            ) {
                if (applicantData[item] === "") {
                    toast.error(`${item} can't be empty`);
                    return false;
                }
            }
        }

        setActiveLink(true);
        if (shouldSave) {
            setisFormLoading('on')
            toast.info(`Submitting... Please wait!`);
            await axios
                .patch(`${serverLink}application/personal/info`, applicantData)
                .then((res) => {
                    if (res.data.message === "success") {
                        props.setOnLoginDetails(applicantData);
                        toast.success(`Record Saved!`);
                        onNext();
                        setisFormLoading('off')
                    } else
                        toast.error(
                            `Something went wrong. Please check your connection and try again!`
                        );
                    setisFormLoading('off')
                })
                .catch((error) => {
                    console.log("NETWORK ERROR", error);
                });
        } else onNext();
    };

    const onPrevious = () => {
        navigate("/undergraduate/admission-type");
    };

    const onNext = () => {
        navigate("/undergraduate/secondary-school-result");
    };
    useEffect(() => {
        if (props.applicationLogin.length === 0) {
            navigate("/login");
        }
    }, [props.applicationLogin])
    return (
        // loading ?
        //     <Loader/>
        //     :
            <>
                <div className="main-wrapper">
                    <Header/>
                    <Sidebar/>
                    <div className="page-wrapper">
                        <div className="content">
                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                    <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                        <div className="my-auto mb-2">
                            <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                            }</h3>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <a href="">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Personal Information</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center mb-5 mt-3" style={{marginTop:"-40px"}}>
                    <div className="col-md-10 d-flex justify-content-center align-items-center min-vh-40">
                        <div className="flex-fill">
                            <br />
                            <form className="login bg-white shadow p-5" onSubmit={handleSubmit}>
                                <h3><b>Personal Information</b></h3>
                                <br/>
                                <div className="row">
                                    {/*{applicantData.m}*/}
                                    <div className="col-4 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="FirstName" className="form-label">
                                                First Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="FirstName"
                                                className="form-control"
                                                placeholder="First Name"
                                                value={applicantData.FirstName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="MiddleName" className="form-label">Middle Name</label>
                                            <input
                                                type="text"
                                                id="MiddleName"
                                                className="form-control"
                                                placeholder="Middle Name"
                                                value={applicantData.MiddleName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="Surname" className="form-label">
                                                Surname <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="Surname"
                                                className="form-control"
                                                placeholder="Surname"
                                                value={applicantData.Surname}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="PhoneNumber" className="form-label">
                                                Phone Number<span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                id="PhoneNumber"
                                                className="form-control"
                                                placeholder="Phone Number"
                                                value={applicantData.PhoneNumber}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-6">
                                        <div className="form-group">
                                            <label htmlFor="DateOfBirth" className="form-label">
                                                Date of Birth <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="date"
                                                id="DateOfBirth"
                                                className="form-control"
                                                placeholder="Date of Birth*"
                                                value={applicantData.DateOfBirth.split("T")[0]}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-4 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="Gender" className="form-label">
                                                Gender <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                id="Gender"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={applicantData.Gender}
                                            >
                                                <option value="">Select Option</option>
                                                <option value="Female">Female</option>
                                                <option value="Male">Male</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="Nationality" className="form-label">
                                                Nationality <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="Nationality"
                                                className="form-control"
                                                placeholder="Nationality"
                                                value={applicantData.Nationality}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="StateOfOrigin" className="form-label">
                                                State of Origin <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                id="StateOfOrigin"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={applicantData.StateOfOrigin}
                                            >
                                                <option value="">Select Option</option>
                                                {stateData.length > 0 &&
                                                    stateData.map((state, index) => {
                                                        return (
                                                            <option key={index} value={state.state}>
                                                                {state.state}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="LGA" className="form-label">Local Government</label>
                                            <select
                                                id="LGA"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={applicantData.LGA}
                                            >
                                                {lgaList.length > 0 &&
                                                    lgaList.map((lga, index) => {
                                                        return (
                                                            <option key={index} value={lga}>
                                                                {lga}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <div className="form-group">
                                            <label htmlFor="Occupation" className="form-label">Occupation</label>
                                            <input
                                                type="text"
                                                id="Occupation"
                                                className="form-control"
                                                placeholder="Occupation"
                                                value={applicantData.Occupation}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-4 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="Religion" className="form-label">
                                                Religion <span className="text-danger">*</span>
                                            </label>
                                            <select
                                                id="Religion"
                                                className="form-control"
                                                onChange={handleChange}
                                                value={
                                                    applicantData?.Religion
                                                        ? applicantData?.Religion
                                                        : undefined
                                                }
                                            >
                                                <option value="">Select Option</option>
                                                <option value="Christianity">Christianity</option>
                                                <option value="Islam">Islam</option>
                                                <option value="Others">Others</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="form-group">
                                        <label htmlFor="Address" className="form-label">
                                            Address <span className="text-danger">*</span>
                                        </label>
                                        <textarea
                                            type="text"
                                            id="Address"
                                            rows="3"
                                            className="form-control"
                                            placeholder="Address"
                                            value={applicantData?.Address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 mt-5">
                                    {isFormLoading === 'on' ?
                                        <button className="btn btn-dark text-center offset-3 w-50" id="kt_modal_new_address_submit">
                                                    <span className="indicator-progress">Please wait...
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2" />
                                                </span>
                                        </button>
                                        :
                                        <div className="filters-group mb-lg-4 text-center">
                                            <button className="btn btn-dark mx-3 active" onClick={onPrevious}> Previous</button>
                                            <button className="btn btn-dark w-50  active" type="submit">  Save and Continue</button>
                                        </div>
                                    }

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                        </div>
                    </div>
                </div>
            </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setOnLoginDetails: (p) => {
            dispatch(setLoginDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
